import {PageLink} from '../../../../_metronic/layout/core'
import {LocaleValueType} from './_models'

export const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const companySocialMediaData = [
  {
    id: 1,
    icon: 'facebook.svg',
    iconLable: 'Facebook',
    placeholder: 'Enter Facebook URL here',
    fieldName: 'socialMedia.facebook',
  },
  {
    id: 2,
    icon: 'twitter.svg',
    iconLable: 'Twitter',
    placeholder: 'Enter Twitter/X URL here',
    fieldName: 'socialMedia.twitter',
  },
  {
    id: 3,
    icon: 'linkedin.svg',
    iconLable: 'LinkedIn',
    placeholder: 'Enter Linkedin URL here',
    fieldName: 'socialMedia.linkedin',
  },
  {
    id: 4,
    icon: 'instagram.svg',
    iconLable: 'Instagram',
    placeholder: 'Enter Instagram URL here',
    fieldName: 'socialMedia.instagram',
  },
  {
    id: 5,
    icon: 'youtube.svg',
    iconLable: 'Youtube',
    placeholder: 'Enter Youtube URL here',
    fieldName: 'socialMedia.youtube',
  },
  {
    id: 6,
    icon: 'reddit.svg',
    iconLable: 'Reddit',
    placeholder: 'Enter Reddit URL here',
    fieldName: 'socialMedia.reddit',
  },
  {
    id: 7,
    icon: 'tiktok.svg',
    iconLable: 'Tiktok',
    placeholder: 'Enter Tiktok URL here',
    fieldName: 'socialMedia.tiktok',
  },
  {
    id: 8,
    icon: 'whatsapp.svg',
    iconLable: 'Whatsapp',
    placeholder: 'Enter Whatsapp URL here',
    fieldName: 'socialMedia.whatsapp',
  },
  {
    id: 9,
    icon: 'telegram.svg',
    iconLable: 'Telegram',
    placeholder: 'Enter Telegram URL here',
    fieldName: 'socialMedia.telegram',
  },
  {
    id: 10,
    icon: 'snapchat.svg',
    iconLable: 'SnapChat',
    placeholder: 'Enter Snapchat URL here',
    fieldName: 'socialMedia.snapchat',
  },
  {
    id: 11,
    icon: 'wechat.svg',
    iconLable: 'WeChat',
    placeholder: 'Enter WeChat URL here',
    fieldName: 'socialMedia.weChat',
  },
  {
    id: 12,
    icon: 'pinterest.svg',
    iconLable: 'Pinterest',
    placeholder: 'Enter Pinterest URL here',
    fieldName: 'socialMedia.pinterest',
  },
  {
    id: 13,
    icon: 'discord.svg',
    iconLable: 'Discord',
    placeholder: 'Enter Discord URL here',
    fieldName: 'socialMedia.discord',
  },
  {
    id: 14,
    icon: 'twitch.svg',
    iconLable: 'Twitch',
    placeholder: 'Enter Twitch URL here',
    fieldName: 'socialMedia.twitch',
  },
]

export const socialMediaData = [
  {
    id: 1,
    icon: 'website.svg',
    iconLable: 'Website',
    placeholder: 'Enter website URL here',
    fieldName: 'socialMedia.website',
  },

  {
    id: 2,
    icon: 'facebook.svg',
    iconLable: 'Facebook',
    placeholder: 'Enter facebook URL here',
    fieldName: 'socialMedia.facebook',
  },
  {
    id: 3,
    icon: 'twitter.svg',
    iconLable: 'Twitter',
    placeholder: 'Enter twitter URL here',
    fieldName: 'socialMedia.twitter',
  },
  {
    id: 4,
    icon: 'linkedin.svg',
    iconLable: 'LinkedIn',
    placeholder: 'Enter linkedin URL here',
    fieldName: 'socialMedia.linkedin',
  },
  {
    id: 5,
    icon: 'instagram.svg',
    iconLable: 'Instagram',
    placeholder: 'Enter instagram URL here',
    fieldName: 'socialMedia.instagram',
  },
]

export const investorsocialMediaData = [
  {
    id: 1,
    icon: 'facebook.svg',
    iconLable: 'Facebook',
    placeholder: 'Enter facebook URL here',
    fieldName: 'socialMedia.facebook',
  },
  {
    id: 2,
    icon: 'twitter.svg',
    iconLable: 'Twitter',
    placeholder: 'Enter twitter URL here',
    fieldName: 'socialMedia.twitter',
  },
  {
    id: 3,
    icon: 'linkedin.svg',
    iconLable: 'LinkedIn',
    placeholder: 'Enter linkedin URL here',
    fieldName: 'socialMedia.linkedin',
  },
  {
    id: 4,
    icon: 'instagram.svg',
    iconLable: 'Instagram',
    placeholder: 'Enter instagram URL here',
    fieldName: 'socialMedia.instagram',
  },
]

export enum OtherSettingsUser {
  HELP_BANNER_DASHBOARD,
}

export const OtherSettingsInput = [
  {
    id: OtherSettingsUser.HELP_BANNER_DASHBOARD,
    title: 'Help Text Banners in Dashboard',
    subtitle: 'Switch this Off to hide all help text banners across the Foundercrate dashboard',
    toggleLabel: 'helpBannerEnabled',
  },
]

export const OtherSettingsOutput = [
  {
    id: OtherSettingsUser.HELP_BANNER_DASHBOARD,
    title: 'Help Text Banners in Dashboard',
    value: false,
  },
]

export enum OtherSettingsCompany {
  DUMMY_DASHBOARD_DATA,
}

export const OtherSettingsCompanyInput = [
  {
    id: OtherSettingsCompany.DUMMY_DASHBOARD_DATA,
    title: 'Dummy Data in Dashboard',
    subtitle:
      'Switching this OFF will replace sample/demo data with live information across all dashboards, providing an accurate view of your fundraising activities.',
    toggleLabel: 'dummyDashboardData',
  },
]

export const OtherSettingsCompanyOutput = [
  {
    id: OtherSettingsCompany.DUMMY_DASHBOARD_DATA,
    title: 'Dummy Data in Dashboard',
    value: false,
  },
]

export enum EmailPreference {
  NEW_INVESTOR_UPDATE = 1,
  PITCH_DECK_UPLOADED,
  INVESTOR_UPDATE_VIEWED,
  UPCOMING_ACTIVITY,
  NEW_TEAM_MEMBER,
  EMAIL_NOTIFICATION,
  DATAROOM_VIEWED,
  INVESTOR_CONFIRMED,
  INVESTOR_REJECTED,
}

export const EmailPreferencesInput = [
  {
    id: EmailPreference.NEW_INVESTOR_UPDATE,
    title: 'New Investor Update is created',
    subtitle:
      'You will receive a notification if any of your team members created an investor update to the company profile on Foundercrate.',
    toggleLabel: 'newInvestorUpdateIsCreated',
  },
  {
    id: EmailPreference.PITCH_DECK_UPLOADED,
    title: 'Pitch Deck Uploaded',
    subtitle:
      'You will receive a notification If any of your team members upload a pitch deck to the company profile on Foundercrate.',
    toggleLabel: 'pitchDeckUploaded',
  },
  {
    id: EmailPreference.INVESTOR_UPDATE_VIEWED,
    title: 'Someone viewed your investor Update',
    subtitle: 'You will receive a notification if an investor views the investor update you sent',
    toggleLabel: 'someoneViewedYourInvestorUpdate',
  },
  {
    id: EmailPreference.UPCOMING_ACTIVITY,
    title: 'Upcoming Scheduled Activity',
    subtitle:
      'You will receive a notification if your team members add new activity with the investor.',
    toggleLabel: 'upcommingScheduledActivity',
  },
  {
    id: EmailPreference.NEW_TEAM_MEMBER,
    title: 'New team Member added to the company',
    subtitle:
      'You will receive a notification if any of your current team members invite an external person to your company profile on Foundercrate.',
    toggleLabel: 'newTeamMemberAddedToTheCompany',
  },
  {
    id: EmailPreference.EMAIL_NOTIFICATION,
    title: 'Email Notification',
    subtitle: 'You will receive a notification when any team member sends an email to investors.',
    toggleLabel: 'emailNotification',
  },
  {
    id: EmailPreference.DATAROOM_VIEWED,
    title: 'Someone Viewed your DataRoom',
    subtitle: `You will receive a notification if any team members or investors have viewed your company's DataRoom.`,
    toggleLabel: 'someoneViewedYourDataRoom',
  },
  {
    id: EmailPreference.INVESTOR_CONFIRMED,
    title: 'Investor Marked as Confirmed',
    subtitle:
      'You will receive a notification if any team members mark an investor as confirmed for the current round.',
    toggleLabel: 'investorMarkedAsConfirmed',
  },
  {
    id: EmailPreference.INVESTOR_REJECTED,
    title: 'Investor Marked as Rejected',
    subtitle:
      'You will receive a notification if any team members mark an investor as rejected for the current round.',
    toggleLabel: 'investorMarkedAsRejected',
  },
]

export const EmailPreferencesOutput = [
  {
    id: EmailPreference.NEW_INVESTOR_UPDATE,
    title: 'New Investor Update is created',
    value: false,
  },
  {
    id: EmailPreference.PITCH_DECK_UPLOADED,
    title: 'Pitch Deck Uploaded',
    value: false,
  },
  {
    id: EmailPreference.INVESTOR_UPDATE_VIEWED,
    title: 'Someone viewed your investor Update',
    value: false,
  },
  {
    id: EmailPreference.UPCOMING_ACTIVITY,
    title: 'Upcoming Scheduled Activity',
    value: false,
  },
  {
    id: EmailPreference.NEW_TEAM_MEMBER,
    title: 'New team Member added to the company',
    value: false,
  },
  {
    id: EmailPreference.EMAIL_NOTIFICATION,
    title: 'Email Notification',
    value: false,
  },
  {
    id: EmailPreference.DATAROOM_VIEWED,
    title: 'Someone Viewed your DataRoom',
    value: false,
  },
  {
    id: EmailPreference.INVESTOR_CONFIRMED,
    title: 'Investor Marked as Confirmed',
    value: false,
  },
  {
    id: EmailPreference.INVESTOR_REJECTED,
    title: 'Investor Marked as Rejected',
    value: false,
  },
]

export const localeOptions = [
  {
    id: 1,
    name: 'English - US',
    value: 'en_US',
  },

  {
    id: 2,
    name: 'Deutsch - German',
    value: 'de_GN',
  },

  {
    id: 3,
    name: 'français - France',
    value: 'fr_FR',
  },
  {
    id: 4,
    name: 'Español - Spain',
    value: 'es_ES',
  },

  {
    id: 5,
    name: '中国人 - China',
    value: 'zh_CN',
  },

  {
    id: 6,
    name: '日本語 - Japan',
    value: 'ja_JP',
  },
  {
    id: 7,
    name: 'हिंदी-Hindi',
    value: 'hi_HI',
  },
  {
    id: 8,
    name: 'বাংলা-Bangla',
    value: 'bn_BN',
  },
  {
    id: 9,
    name: 'italiano-Italian',
    value: 'it_IT',
  },
  {
    id: 10,
    name: '한국인-Korean',
    value: 'ko_KO',
  },
  {
    id: 11,
    name: 'Português-Portuguese',
    value: 'pt_PT',
  },
  {
    id: 12,
    name: 'Русский-Russian',
    value: 'ru_RU',
  },
]

export const dateFormatOptions = [
  {
    id: 1,
    name: '03 Sep, 2023',
    value: 'DD MMM, YYYY',
  },
  {
    id: 2,
    name: 'Sep 03, 2023',
    value: 'MMM DD, YYYY',
  },
  {
    id: 3,
    name: 'September 03, 2023',
    value: 'MMMM DD, YYYY',
  },
  {
    id: 4,
    name: '09/03/2023',
    value: 'MM/DD/YYYY',
  },
  {
    id: 5,
    name: '03/09/23',
    value: 'DD/MM/YY',
  },
  {
    id: 6,
    name: '03/09/2023',
    value: 'DD/MM/YYYY',
  },
  {
    id: 7,
    name: '03-09-2023',
    value: 'DD-MM-YYYY',
  },
  {
    id: 8,
    name: '2023/09/03',
    value: 'YYYY/MM/DD',
  },

  {
    id: 9,
    name: '2023-09-03',
    value: 'YYYY-MM-DD',
  },
]

export const timeFormatOptions = [
  {
    id: 1,
    name: '14:5:3',
    value: 'H:m:s',
  },
  {
    id: 2,
    name: '14:05:03',
    value: 'HH:mm:ss',
  },
  {
    id: 3,
    name: '2:5:3 PM',
    value: 'h:m:s a',
  },
  {
    id: 4,
    name: '2:05:03',
    value: 'h:mm:ss',
  },
  {
    id: 5,
    name: '2:05:03 PM',
    value: 'h:mm:ss a',
  },
  {
    id: 6,
    name: '02:05:03 PM',
    value: 'hh:mm:ss a',
  },
]

export const timeZoneOptions = [
  {
    id: 1,
    name: '(UTC-12:00) International Date Line West',
    value: 'UTC-12:00',
  },
  {
    id: 2,
    name: '(UTC-11:00) Coordinated Universal Time-11',
    value: 'UTC-11:00',
  },
  {
    id: 3,
    name: '(UTC-10:00) Hawaii',
    value: 'UTC-10:00',
  },
  {
    id: 4,
    name: '(UTC-09:00) Alaska',
    value: 'UTC-09:00',
  },
  {
    id: 5,
    name: '(UTC-08:00) Baja California',
    value: 'UTC-08:00',
  },
  {
    id: 6,
    name: '(UTC-07:00) Pacific Daylight Time (US & Canada)',
    value: 'UTC-07:00',
  },
  {
    id: 7,
    name: '(UTC-08:00) Pacific Standard Time (US & Canada)',
    value: 'UTC-08:00',
  },
  {
    id: 8,
    name: '(UTC-07:00) Arizona',
    value: 'UTC-07:00',
  },
  {
    id: 9,
    name: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    value: 'UTC-07:00',
  },
  {
    id: 10,
    name: '(UTC-07:00) Mountain Time (US & Canada)',
    value: 'UTC-07:00',
  },
  {
    id: 11,
    name: '(UTC-06:00) Central America',
    value: 'UTC-06:00',
  },
  {
    id: 12,
    name: '(UTC-06:00) Central Time (US & Canada)',
    value: 'UTC-06:00',
  },
  {
    id: 13,
    name: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    value: 'UTC-06:00',
  },
  {
    id: 14,
    name: '(UTC-06:00) Saskatchewan',
    value: 'UTC-06:00',
  },
  {
    id: 15,
    name: '(UTC-05:00) Bogota, Lima, Quito',
    value: 'UTC-05:00',
  },
  {
    id: 16,
    name: '(UTC-05:00) Eastern Time (US & Canada)',
    value: 'UTC-05:00',
  },
  {
    id: 17,
    name: '(UTC-04:00) Eastern Daylight Time (US & Canada)',
    value: 'UTC-04:00',
  },
  {
    id: 18,
    name: '(UTC-05:00) Indiana (East)',
    value: 'UTC-05:00',
  },
  {
    id: 19,
    name: '(UTC-04:30) Caracas',
    value: 'UTC-04:30',
  },
  {
    id: 20,
    name: '(UTC-04:00) Asuncion',
    value: 'UTC-04:00',
  },
  {
    id: 21,
    name: '(UTC-04:00) Atlantic Time (Canada)',
    value: 'UTC-04:00',
  },
  {
    id: 22,
    name: '(UTC-04:00) Cuiaba',
    value: 'UTC-04:00',
  },
  {
    id: 23,
    name: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    value: 'UTC-04:00',
  },
  {
    id: 24,
    name: '(UTC-04:00) Santiago',
    value: 'UTC-04:00',
  },
  {
    id: 25,
    name: '(UTC-03:30) Newfoundland',
    value: 'UTC-03:30',
  },
  {
    id: 26,
    name: '(UTC-03:00) Brasilia',
    value: 'UTC-03:00',
  },
  {
    id: 27,
    name: '(UTC-03:00) Buenos Aires',
    value: 'UTC-03:00',
  },
  {
    id: 28,
    name: '(UTC-03:00) Cayenne, Fortaleza',
    value: 'UTC-03:00',
  },
  {
    id: 29,
    name: '(UTC-03:00) Greenland',
    value: 'UTC-03:00',
  },
  {
    id: 30,
    name: '(UTC-03:00) Montevideo',
    value: 'UTC-03:00',
  },
  {
    id: 31,
    name: '(UTC-03:00) Salvador',
    value: 'UTC-03:00',
  },
  {
    id: 32,
    name: '(UTC-02:00) Coordinated Universal Time-02',
    value: 'UTC-02:00',
  },
  {
    id: 33,
    name: '(UTC-02:00) Mid-Atlantic - Old',
    value: 'UTC-02:00',
  },
  {
    id: 34,
    name: '(UTC-01:00) Azores',
    value: 'UTC-01:00',
  },
  {
    id: 35,
    name: '(UTC-01:00) Cape Verde Is.',
    value: 'UTC-01:00',
  },
  {
    id: 36,
    name: '(UTC) Casablanca',
    value: 'UTC',
  },
  {
    id: 37,
    name: '(UTC) Coordinated Universal Time',
    value: 'UTC',
  },
  {
    id: 38,
    name: '(UTC) Edinburgh, London',
    value: 'UTC',
  },
  {
    id: 39,
    name: '(UTC+01:00) Edinburgh, London',
    value: 'UTC+01:00',
  },
  {
    id: 40,
    name: '(UTC) Dublin, Lisbon',
    value: 'UTC',
  },
  {
    id: 41,
    name: '(UTC) Monrovia, Reykjavik',
    value: 'UTC',
  },
  {
    id: 42,
    name: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'UTC+01:00',
  },
  {
    id: 43,
    name: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    value: 'UTC+01:00',
  },
  {
    id: 44,
    name: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    value: 'UTC+01:00',
  },
  {
    id: 45,
    name: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    value: 'UTC+01:00',
  },
  {
    id: 46,
    name: '(UTC+01:00) West Central Africa',
    value: 'UTC+01:00',
  },
  {
    id: 47,
    name: '(UTC+01:00) Windhoek',
    value: 'UTC+01:00',
  },
  {
    id: 48,
    name: '(UTC+02:00) Athens, Bucharest',
    value: 'UTC+02:00',
  },
  {
    id: 49,
    name: '(UTC+02:00) Beirut',
    value: 'UTC+02:00',
  },
  {
    id: 50,
    name: '(UTC+02:00) Cairo',
    value: 'UTC+02:00',
  },
  {
    id: 51,
    name: '(UTC+02:00) Damascus',
    value: 'UTC+02:00',
  },
  {
    id: 52,
    name: '(UTC+02:00) E. Europe',
    value: 'UTC+02:00',
  },
  {
    id: 53,
    name: '(UTC+02:00) Harare, Pretoria',
    value: 'UTC+02:00',
  },
  {
    id: 54,
    name: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    value: 'UTC+02:00',
  },
  {
    id: 55,
    name: '(UTC+03:00) Istanbul',
    value: 'UTC+03:00',
  },
  {
    id: 56,
    name: '(UTC+02:00) Jerusalem',
    value: 'UTC+02:00',
  },
  {
    id: 57,
    name: '(UTC+02:00) Tripoli',
    value: 'UTC+02:00',
  },
  {
    id: 58,
    name: '(UTC+03:00) Amman',
    value: 'UTC+03:00',
  },
  {
    id: 59,
    name: '(UTC+03:00) Baghdad',
    value: 'UTC+03:00',
  },
  {
    id: 60,
    name: '(UTC+02:00) Kaliningrad',
    value: 'UTC+02:00',
  },
  {
    id: 61,
    name: '(UTC+03:00) Kuwait, Riyadh',
    value: 'UTC+03:00',
  },
  {
    id: 62,
    name: '(UTC+03:00) Nairobi',
    value: 'UTC+03:00',
  },
  {
    id: 63,
    name: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
    value: 'UTC+03:00',
  },
  {
    id: 64,
    name: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
    value: 'UTC+04:00',
  },
  {
    id: 65,
    name: '(UTC+03:30) Tehran',
    value: 'UTC+03:30',
  },
  {
    id: 66,
    name: '(UTC+04:00) Abu Dhabi, Muscat',
    value: 'UTC+04:00',
  },
  {
    id: 67,
    name: '(UTC+04:00) Baku',
    value: 'UTC+04:00',
  },
  {
    id: 68,
    name: '(UTC+04:00) Port Louis',
    value: 'UTC+04:00',
  },
  {
    id: 69,
    name: '(UTC+04:00) Tbilisi',
    value: 'UTC+04:00',
  },
  {
    id: 70,
    name: '(UTC+04:00) Yerevan',
    value: 'UTC+04:00',
  },
  {
    id: 71,
    name: '(UTC+04:30) Kabul',
    value: 'UTC+04:30',
  },
  {
    id: 72,
    name: '(UTC+05:00) Ashgabat, Tashkent',
    value: 'UTC+05:00',
  },
  {
    id: 73,
    name: '(UTC+05:00) Yekaterinburg',
    value: 'UTC+05:00',
  },
  {
    id: 74,
    name: '(UTC+05:00) Islamabad, Karachi',
    value: 'UTC+05:00',
  },
  {
    id: 75,
    name: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'UTC+05:30',
  },
  {
    id: 76,
    name: '(UTC+05:30) Sri Jayawardenepura',
    value: 'UTC+05:30',
  },
  {
    id: 77,
    name: '(UTC+05:45) Kathmandu',
    value: 'UTC+05:45',
  },
  {
    id: 78,
    name: '(UTC+06:00) Nur-Sultan (Astana)',
    value: 'UTC+06:00',
  },
  {
    id: 79,
    name: '(UTC+06:00) Dhaka',
    value: 'UTC+06:00',
  },
  {
    id: 80,
    name: '(UTC+06:30) Yangon (Rangoon)',
    value: 'UTC+06:30',
  },
  {
    id: 81,
    name: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    value: 'UTC+07:00',
  },
  {
    id: 82,
    name: '(UTC+07:00) Novosibirsk',
    value: 'UTC+07:00',
  },
  {
    id: 83,
    name: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'UTC+08:00',
  },
  {
    id: 84,
    name: '(UTC+08:00) Krasnoyarsk',
    value: 'UTC+08:00',
  },
  {
    id: 85,
    name: '(UTC+08:00) Kuala Lumpur, Singapore',
    value: 'UTC+08:00',
  },
  {
    id: 86,
    name: '(UTC+08:00) Perth',
    value: 'UTC+08:00',
  },
  {
    id: 87,
    name: '(UTC+08:00) Taipei',
    value: 'UTC+08:00',
  },
  {
    id: 88,
    name: '(UTC+08:00) Ulaanbaatar',
    value: 'UTC+08:00',
  },
  {
    id: 89,
    name: '(UTC+08:00) Irkutsk',
    value: 'UTC+08:00',
  },
  {
    id: 90,
    name: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    value: 'UTC+09:00',
  },
  {
    id: 91,
    name: '(UTC+09:00) Seoul',
    value: 'UTC+09:00',
  },
  {
    id: 92,
    name: '(UTC+09:30) Adelaide',
    value: 'UTC+09:30',
  },
  {
    id: 93,
    name: '(UTC+09:30) Darwin',
    value: 'UTC+09:30',
  },
  {
    id: 94,
    name: '(UTC+10:00) Brisbane',
    value: 'UTC+10:00',
  },
  {
    id: 95,
    name: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 'UTC+10:00',
  },
  {
    id: 96,
    name: '(UTC+10:00) Guam, Port Moresby',
    value: 'UTC+10:00',
  },
  {
    id: 97,
    name: '(UTC+10:00) Hobart',
    value: 'UTC+10:00',
  },
  {
    id: 98,
    name: '(UTC+09:00) Yakutsk',
    value: 'UTC+09:00',
  },
  {
    id: 99,
    name: '(UTC+11:00) Solomon Is., New Caledonia',
    value: 'UTC+11:00',
  },
  {
    id: 100,
    name: '(UTC+11:00) Vladivostok',
    value: 'UTC+11:00',
  },
  {
    id: 101,
    name: '(UTC+12:00) Auckland, Wellington',
    value: 'UTC+12:00',
  },
  {
    id: 102,
    name: '(UTC+12:00) Coordinated Universal Time+12',
    value: 'UTC+12:00',
  },
  {
    id: 103,
    name: '(UTC+12:00) Fiji',
    value: 'UTC+12:00',
  },
  {
    id: 104,
    name: '(UTC+12:00) Magadan',
    value: 'UTC+12:00',
  },
  {
    id: 105,
    name: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    value: 'UTC+12:00',
  },
  {
    id: 106,
    name: "(UTC+13:00) Nuku'alofa",
    value: 'UTC+13:00',
  },
  {
    id: 107,
    name: '(UTC+13:00) Samoa',
    value: 'UTC+13:00',
  },
]

export const timeStampOptions = [
  {
    id: 1,
    name: 'ISO 8601 - 2023-02-17T05:58:58+05:30',
    value: 'YYYY-MM-DDTHH:mm:ssZ',
  },
  {
    id: 2,
    name: 'Unix time - 1676593738 (seconds since epoch)',
    value: 'seconds since 1970-01-01 00:00:00 UTC',
  },
  {
    id: 3,
    name: 'RFC 2822 - Fri, 17 Feb 2023 00:28:58 GMT',
    value: 'ddd, DD MMM YYYY HH:mm:ss Z',
  },
  {
    id: 5,
    name: 'JavaScript - 1676593738000 (milliseconds since epoch)',
    value: 'YYYY-MM-DDTHH:mm:ssZ',
  },
]

export const designationOptions = [
  {
    id: 1,
    name: 'CXO',
    value: 'CXO',
  },
  {
    id: 2,
    name: 'Charter Accountant - CA',
    value: 'Charter Accountant - CA',
  },
  {
    id: 3,
    name: 'Company Secretary - CS',
    value: 'Company Secretary - CS',
  },
  {
    id: 4,
    name: 'Accountant',
    value: 'Accountant',
  },
  {
    id: 5,
    name: 'Director',
    value: 'Director',
  },
  {
    id: 6,
    name: 'Investment Banker',
    value: 'Investment Banker',
  },
  {
    id: 7,
    name: 'Lawyer',
    value: 'Lawyer',
  },
  {
    id: 8,
    name: 'Admin',
    value: 'Admin',
  },
  {
    id: 9,
    name: 'Founder',
    value: 'Founder',
  },
  {
    id: 10,
    name: 'Co-Founder',
    value: 'Co-Founder',
  },
  {
    id: 11,
    name: 'CEO',
    value: 'CEO',
  },
  {
    id: 12,
    name: 'CTO',
    value: 'CTO',
  },
  {
    id: 13,
    name: 'CFO',
    value: 'CFO',
  },
  {
    id: 14,
    name: 'Others',
    value: 'Others',
  },
]

export const operatingStatusOptions = [
  {
    id: 1,
    name: 'Pre-launch',
    value: 'Pre-launch',
  },
  {
    id: 2,
    name: 'Active',
    value: 'Active',
  },
  {
    id: 3,
    name: 'Inactive',
    value: 'Inactive',
  },
  {
    id: 4,
    name: 'Shutdown',
    value: 'Shutdown',
  },
  {
    id: 5,
    name: 'Liquidated',
    value: 'Liquidated',
  },
]

export const teamSizeOptions = [
  {id: 1, name: '1-2', value: '2'},
  {id: 2, name: '2-10', value: '10'},
  {id: 3, name: '10-30', value: '30'},
  {id: 4, name: '30-50', value: '50'},
  {id: 5, name: '50-100', value: '100'},
  {id: 6, name: '100-500', value: '500'},
  {id: 7, name: '500-1000', value: '1000'},
  {id: 8, name: '1000+', value: '5000'},
]

export const userInitialValues = {
  firstName: '',
  lastName: '',
  designation: '',
  email: '',
  contactNumber: '',
  countryDialingCode: '',
  country: '',
  state: '',
  city: '',
  zipCode: 0,
  communication: {
    email: false,
    phone: false,
  },
  profileImageId: '',
}

export const companyInitialValues = {
  companyName: '',
  tagline: '',
  teamSize: '',
  legalName: '',
  operatingStatus: '',
  currencyId: 0,
  shortDescription: '',
  description: '',
  foundedDate: '',
  industry: '',
  country: '',
  state: '',
  city: '',
  zipCode: 0,
  founders: '',
  logoId: '',
  featuredImageId: '',
  lightLogoId: '',
  darkLogoId: '',
  USP: '',
  problemStatement: '',
  hashtags: [],
  socialMedia: {
    website: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    webApp: '',
    iosApp: '',
    androidApp: '',
    youtube: '',
    reddit: '',
    tiktok: '',
    whatsapp: '',
    telegram: '',
    snapchat: '',
    weChat: '',
    pinterest: '',
    discord: '',
    twitch: '',
  },
}

export const localeInitialValues: LocaleValueType | any = {
  locale: '',
  timezone: '',
  dateFormat: '',
  timeFormat: '',
  timestampFormat: '',
}

export const customSmtpOptions = [
  {id: 1, name: 'SSL', value: 'SSL'},
  {id: 2, name: 'STARTTLS', value: 'STARTTLS'},
  {id: 3, name: 'TLS', value: 'TLS'},
]

export enum Roles {
  // ADMIN = 'admin',
  // BILLING = 'billing',
  // IRM = 'irm',
  // FRM = 'frm',
  // CURATOR = 'curator',
  OWNER = 'owner',
}

export const RolesName: any = {
  admin: 'Admin',
  billing: 'Billing Manager',
  irm: 'Investor Relationship Manager',
  frm: 'Fund Raise Manager',
  curator: 'Investor Curator',
  owner: 'Super Admin (Owner)',
}
export const postmarkInitialValues = {
  serverToken: '',
}

export const initialValues = {
  apiKey: '',
}

export const customSmtpInitialValues = {
  server: '',
  username: '',
  password: '',
  encryption: '',
  port: '',
}

export const senderInitialValues = {
  fromName: '',
  fromEmail: '',
  replyToName: '',
  replyToEmail: '',
  nylasFromName: '',
  nylasFromEmail: '',
  nylasReplyToName: '',
  nylasReplyToEmail: '',
}

export const nylasGoogleInitialValues = {
  grantId: '',
}

export const nylasMicrosoftInitialValues = {
  grantId: '',
}

export const errorMessage = {
  UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED:
    "You've reached the limit for this resource in your current plan. Upgrade your subscription to gain full access.",
  UPGRADE_BILLING_PLAN_FEATURE:
    'This feature is not included in your current plan. Upgrade your subscription to unlock access.',
}

export const referralSources = [
  {id: 1, name: 'Google Search/Ads', value: 'Google Search/Ads'},
  {id: 2, name: 'Bing Search', value: 'Bing Search'},
  {id: 3, name: 'Social Media (Posts & Ads)', value: 'Social Media (Posts & Ads)'},
  {id: 4, name: 'LinkedIn', value: 'LinkedIn'},
  {id: 5, name: 'Email Newsletters', value: 'Email Newsletters'},
  {id: 6, name: 'Promotional Emails', value: 'Promotional Emails'},
  {
    id: 7,
    name: 'Referred by Colleagues, Friends, or Family',
    value: 'Referred by Colleagues, Friends, or Family',
  },
  {id: 8, name: 'Blogs or Articles', value: 'Blogs or Articles'},
  {id: 9, name: 'Affiliate Links', value: 'Affiliate Links'},
  {id: 10, name: 'Software Review Sites', value: 'Software Review Sites'},
  {id: 11, name: 'Webinars or Online Events', value: 'Webinars or Online Events'},
  {id: 12, name: 'YouTube Channel', value: 'YouTube Channel'},
  {id: 13, name: 'Others', value: 'Others'},
]

export const phoneCodes: any = [
  {
    dial_code: '+93',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/af.png`,
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    dial_code: '+358',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ax.png`,
    code: 'AX',
    name: 'Aland Islands',
  },
  {
    dial_code: '+355',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/al.png`,
    code: 'AL',
    name: 'Albania',
  },
  {
    dial_code: '+213',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/dz.png`,
    code: 'DZ',
    name: 'Algeria',
  },
  {
    dial_code: '+1684',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/as.png`,
    code: 'AS',
    name: 'American Samoa',
  },
  {
    dial_code: '+376',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ad.png`,
    code: 'AD',
    name: 'Andorra',
  },
  {
    dial_code: '+244',
    flag: 'https://foundercrate-public-assets.s3.ap-south-1.amazonaws.com/flags/flags-icon/ao.png',
    code: 'AO',
    name: 'Angola',
  },
  {
    dial_code: '+1264',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ai.png`,
    code: 'AI',
    name: 'Anguilla',
  },
  {
    dial_code: '+672',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/aq.png`,
    code: 'AQ',
    name: 'Antarctica',
  },
  {
    dial_code: '+1268',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ag.png`,
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    dial_code: '+54',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ar.png`,
    code: 'AR',
    name: 'Argentina',
  },
  {
    dial_code: '+374',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/am.png`,
    code: 'AM',
    name: 'Armenia',
  },
  {
    dial_code: '+297',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/aw.png`,
    code: 'AW',
    name: 'Aruba',
  },
  {
    dial_code: '+61',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/au.png`,
    code: 'AU',
    name: 'Australia',
  },
  {
    dial_code: '+43',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/at.png`,
    code: 'AT',
    name: 'Austria',
  },
  {
    dial_code: '+994',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/az.png`,
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    dial_code: '+1242',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bs.png`,
    code: 'BS',
    name: 'Bahamas',
  },
  {
    dial_code: '+973',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bh.png`,
    code: 'BH',
    name: 'Bahrain',
  },
  {
    dial_code: '+880',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bd.png`,
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    dial_code: '+1246',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bb.png`,
    code: 'BB',
    name: 'Barbados',
  },
  {
    dial_code: '+375',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/by.png`,
    code: 'BY',
    name: 'Belarus',
  },
  {
    dial_code: '+32',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/be.png`,
    code: 'BE',
    name: 'Belgium',
  },
  {
    dial_code: '+501',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bz.png`,
    code: 'BZ',
    name: 'Belize',
  },
  {
    dial_code: '+229',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bj.png`,
    code: 'BJ',
    name: 'Benin',
  },
  {
    dial_code: '+1441',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bm.png`,
    code: 'BM',
    name: 'Bermuda',
  },
  {
    dial_code: '+975',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bt.png`,
    code: 'BT',
    name: 'Bhutan',
  },
  {
    dial_code: '+591',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bo.png`,
    code: 'BO',
    name: 'Bolivia',
  },
  {
    dial_code: '+599',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bq.png`,
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    dial_code: '+387',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ba.png`,
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    dial_code: '+267',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bw.png`,
    code: 'BW',
    name: 'Botswana',
  },
  {
    dial_code: '+55',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bv.png`,
    code: 'BV',
    name: 'Bouvet Island',
  },
  {
    dial_code: '+55',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/br.png`,
    code: 'BR',
    name: 'Brazil',
  },
  {
    dial_code: '+246',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/io.png`,
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    dial_code: '+673',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bn.png`,
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    dial_code: '+359',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bg.png`,
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    dial_code: '+226',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bf.png`,
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    dial_code: '+257',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bi.png`,
    code: 'BI',
    name: 'Burundi',
  },
  {
    dial_code: '+855',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kh.png`,
    code: 'KH',
    name: 'Cambodia',
  },
  {
    dial_code: '+237',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cm.png`,
    code: 'CM',
    name: 'Cameroon',
  },
  {
    dial_code: '+1',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ca.png`,
    code: 'CA',
    name: 'Canada',
  },
  {
    dial_code: '+238',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cv.png`,
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    dial_code: '+1345',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ky.png`,
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    dial_code: '+236',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cf.png`,
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    dial_code: '+235',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/td.png`,
    code: 'TD',
    name: 'Chad',
  },
  {
    dial_code: '+56',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cl.png`,
    code: 'CL',
    name: 'Chile',
  },
  {
    dial_code: '+86',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cn.png`,
    code: 'CN',
    name: 'China',
  },
  {
    dial_code: '+61',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cx.png`,
    code: 'CX',
    name: 'Christmas Island',
  },
  {
    dial_code: '+672',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cc.png`,
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    dial_code: '+57',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/co.png`,
    code: 'CO',
    name: 'Colombia',
  },
  {
    dial_code: '+269',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/km.png`,
    code: 'KM',
    name: 'Comoros',
  },
  {
    dial_code: '+242',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cg.png`,
    code: 'CG',
    name: 'Congo',
  },
  {
    dial_code: '+242',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cd.png`,
    code: 'CD',
    name: 'Congo, Democratic Republic of the Congo',
  },
  {
    dial_code: '+682',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ck.png`,
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    dial_code: '+506',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cr.png`,
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    dial_code: '+225',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ci.png`,
    code: 'CI',
    name: "Cote D'Ivoire",
  },
  {
    dial_code: '+385',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/hr.png`,
    code: 'HR',
    name: 'Croatia',
  },
  {
    dial_code: '+53',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cu.png`,
    code: 'CU',
    name: 'Cuba',
  },
  {
    dial_code: '+599',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cw.png`,
    code: 'CW',
    name: 'Curacao',
  },
  {
    dial_code: '+357',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cy.png`,
    code: 'CY',
    name: 'Cyprus',
  },
  {
    dial_code: '+420',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cz.png`,
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    dial_code: '+45',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/dk.png`,
    code: 'DK',
    name: 'Denmark',
  },
  {
    dial_code: '+253',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/dj.png`,
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    dial_code: '+1767',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/dm.png`,
    code: 'DM',
    name: 'Dominica',
  },
  {
    dial_code: '+1809',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/do.png`,
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    dial_code: '+593',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ec.png`,
    code: 'EC',
    name: 'Ecuador',
  },
  {
    dial_code: '+20',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/eg.png`,
    code: 'EG',
    name: 'Egypt',
  },
  {
    dial_code: '+503',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sv.png`,
    code: 'SV',
    name: 'El Salvador',
  },
  {
    dial_code: '+240',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gq.png`,
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    dial_code: '+291',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/er.png`,
    code: 'ER',
    name: 'Eritrea',
  },
  {
    dial_code: '+372',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ee.png`,
    code: 'EE',
    name: 'Estonia',
  },
  {
    dial_code: '+251',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/et.png`,
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    dial_code: '+500',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fk.png`,
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    dial_code: '+298',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fo.png`,
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    dial_code: '+679',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fj.png`,
    code: 'FJ',
    name: 'Fiji',
  },
  {
    dial_code: '+358',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fi.png`,
    code: 'FI',
    name: 'Finland',
  },
  {
    dial_code: '+33',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fr.png`,
    code: 'FR',
    name: 'France',
  },
  {
    dial_code: '+594',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gf.png`,
    code: 'GF',
    name: 'French Guiana',
  },
  {
    dial_code: '+689',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pf.png`,
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    dial_code: '+262',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tf.png`,
    code: 'TF',
    name: 'French Southern Territories',
  },
  {
    dial_code: '+241',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ga.png`,
    code: 'GA',
    name: 'Gabon',
  },
  {
    dial_code: '+220',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gm.png`,
    code: 'GM',
    name: 'Gambia',
  },
  {
    dial_code: '+995',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ge.png`,
    code: 'GE',
    name: 'Georgia',
  },
  {
    dial_code: '+49',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/de.png`,
    code: 'DE',
    name: 'Germany',
  },
  {
    dial_code: '+233',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gh.png`,
    code: 'GH',
    name: 'Ghana',
  },
  {
    dial_code: '+350',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gi.png`,
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    dial_code: '+30',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gr.png`,
    code: 'GR',
    name: 'Greece',
  },
  {
    dial_code: '+299',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gl.png`,
    code: 'GL',
    name: 'Greenland',
  },
  {
    dial_code: '+1473',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gd.png`,
    code: 'GD',
    name: 'Grenada',
  },
  {
    dial_code: '+590',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gp.png`,
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    dial_code: '+1671',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gu.png`,
    code: 'GU',
    name: 'Guam',
  },
  {
    dial_code: '+502',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gt.png`,
    code: 'GT',
    name: 'Guatemala',
  },
  {
    dial_code: '+44',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gg.png`,
    code: 'GG',
    name: 'Guernsey',
  },
  {
    dial_code: '+224',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gn.png`,
    code: 'GN',
    name: 'Guinea',
  },
  {
    dial_code: '+245',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gw.png`,
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    dial_code: '+592',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gy.png`,
    code: 'GY',
    name: 'Guyana',
  },
  {
    dial_code: '+509',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ht.png`,
    code: 'HT',
    name: 'Haiti',
  },
  {
    dial_code: '+0',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/hm.png`,
    code: 'HM',
    name: 'Heard Island and Mcdonald Islands',
  },
  {
    dial_code: '+39',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/va.png`,
    code: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    dial_code: '+504',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/hn.png`,
    code: 'HN',
    name: 'Honduras',
  },
  {
    dial_code: '+852',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/hk.png`,
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    dial_code: '+36',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/hu.png`,
    code: 'HU',
    name: 'Hungary',
  },
  {
    dial_code: '+354',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/is.png`,
    code: 'IS',
    name: 'Iceland',
  },
  {
    dial_code: '+91',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/in.png`,
    code: 'IN',
    name: 'India',
  },
  {
    dial_code: '+62',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/id.png`,
    code: 'ID',
    name: 'Indonesia',
  },
  {
    dial_code: '+98',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ir.png`,
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    dial_code: '+964',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/iq.png`,
    code: 'IQ',
    name: 'Iraq',
  },
  {
    dial_code: '+353',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ie.png`,
    code: 'IE',
    name: 'Ireland',
  },
  {
    dial_code: '+44',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/im.png`,
    code: 'IM',
    name: 'Isle of Man',
  },
  {
    dial_code: '+972',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/il.png`,
    code: 'IL',
    name: 'Israel',
  },
  {
    dial_code: '+39',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/it.png`,
    code: 'IT',
    name: 'Italy',
  },
  {
    dial_code: '+1876',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/at.png`,
    code: 'JM',
    name: 'Jamaica',
  },
  {
    dial_code: '+81',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/jp.png`,
    code: 'JP',
    name: 'Japan',
  },
  {
    dial_code: '+44',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/je.png`,
    code: 'JE',
    name: 'Jersey',
  },
  {
    dial_code: '+962',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/jo.png`,
    code: 'JO',
    name: 'Jordan',
  },
  {
    dial_code: '+7',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kz.png`,
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    dial_code: '+254',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ke.png`,
    code: 'KE',
    name: 'Kenya',
  },
  {
    dial_code: '+686',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ki.png`,
    code: 'KI',
    name: 'Kiribati',
  },
  {
    dial_code: '+850',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kp.png`,
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    dial_code: '+82',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kr.png`,
    code: 'KR',
    name: 'Korea, Republic of',
  },
  {
    dial_code: '+383',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/xk.png`,
    code: 'XK',
    name: 'Kosovo',
  },
  {
    dial_code: '+965',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kw.png`,
    code: 'KW',
    name: 'Kuwait',
  },
  {
    dial_code: '+996',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kg.png`,
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    dial_code: '+856',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/la.png`,
    code: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    dial_code: '+371',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lv.png`,
    code: 'LV',
    name: 'Latvia',
  },
  {
    dial_code: '+961',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lb.png`,
    code: 'LB',
    name: 'Lebanon',
  },
  {
    dial_code: '+266',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ls.png`,
    code: 'LS',
    name: 'Lesotho',
  },
  {
    dial_code: '+231',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lr.png`,
    code: 'LR',
    name: 'Liberia',
  },
  {
    dial_code: '+218',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ly.png`,
    code: 'LY',
    name: 'Libyan Arab Jamahiriya',
  },
  {
    dial_code: '+423',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/li.png`,
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    dial_code: '+370',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lt.png`,
    code: 'LT',
    name: 'Lithuania',
  },
  {
    dial_code: '+352',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lu.png`,
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    dial_code: '+853',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mo.png`,
    code: 'MO',
    name: 'Macao',
  },
  {
    dial_code: '+389',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mk.png`,
    code: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
  },
  {
    dial_code: '+261',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mg.png`,
    code: 'MG',
    name: 'Madagascar',
  },
  {
    dial_code: '+265',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mw.png`,
    code: 'MW',
    name: 'Malawi',
  },
  {
    dial_code: '+60',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/my.png`,
    code: 'MY',
    name: 'Malaysia',
  },
  {
    dial_code: '+960',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mv.png`,
    code: 'MV',
    name: 'Maldives',
  },
  {
    dial_code: '+223',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ml.png`,
    code: 'ML',
    name: 'Mali',
  },
  {
    dial_code: '+356',
    icon: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mt.png`,
    code: 'MT',
    name: 'Malta',
  },
  {
    dial_code: '+692',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mh.png`,
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    dial_code: '+596',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mq.png`,
    code: 'MQ',
    name: 'Martinique',
  },
  {
    dial_code: '+222',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mr.png`,
    code: 'MR',
    name: 'Mauritania',
  },
  {
    dial_code: '+230',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mu.png`,
    code: 'MU',
    name: 'Mauritius',
  },
  {
    dial_code: '+262',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/yt.png`,
    code: 'YT',
    name: 'Mayotte',
  },
  {
    dial_code: '+52',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mx.png`,
    code: 'MX',
    name: 'Mexico',
  },
  {
    dial_code: '+691',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/fm.png`,
    code: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    dial_code: '+373',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/md.png`,
    code: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    dial_code: '+377',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mc.png`,
    code: 'MC',
    name: 'Monaco',
  },
  {
    dial_code: '+976',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mn.png`,
    code: 'MN',
    name: 'Mongolia',
  },
  {
    dial_code: '+382',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/me.png`,
    code: 'ME',
    name: 'Montenegro',
  },
  {
    dial_code: '+1664',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ms.png`,
    code: 'MS',
    name: 'Montserrat',
  },
  {
    dial_code: '+212',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ma.png`,
    code: 'MA',
    name: 'Morocco',
  },
  {
    dial_code: '+258',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mz.png`,
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    dial_code: '+95',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mm.png`,
    code: 'MM',
    name: 'Myanmar',
  },
  {
    dial_code: '+264',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/na.png`,
    code: 'NA',
    name: 'Namibia',
  },
  {
    dial_code: '+674',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nr.png`,
    code: 'NR',
    name: 'Nauru',
  },
  {
    dial_code: '+977',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/np.png`,
    code: 'NP',
    name: 'Nepal',
  },
  {
    dial_code: '+31',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nl.png`,
    code: 'NL',
    name: 'Netherlands',
  },
  {
    dial_code: '+599',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/an.png`,
    code: 'AN',
    name: 'Netherlands Antilles',
  },
  {
    dial_code: '+687',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nc.png`,
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    dial_code: '+64',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nz.png`,
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    dial_code: '+505',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ni.png`,
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    dial_code: '+227',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ne.png`,
    code: 'NE',
    name: 'Niger',
  },
  {
    dial_code: '+234',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ng.png`,
    code: 'NG',
    name: 'Nigeria',
  },
  {
    dial_code: '+683',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nu.png`,
    code: 'NU',
    name: 'Niue',
  },
  {
    dial_code: '+672',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/nf.png`,
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    dial_code: '+1670',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mp.png`,
    code: 'MP',
    name: 'Northern Mariana Islands',
  },

  {
    dial_code: '+47',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/no.png`,
    code: 'NO',
    name: 'Norway',
  },
  {
    dial_code: '+968',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/om.png`,
    code: 'OM',
    name: 'Oman',
  },
  {
    dial_code: '+92',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pk.png`,
    code: 'PK',
    name: 'Pakistan',
  },
  {
    dial_code: '+680',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pw.png`,
    code: 'PW',
    name: 'Palau',
  },
  {
    dial_code: '+970',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ps.png`,
    code: 'PS',
    name: 'Palestinian Territory, Occupied',
  },
  {
    dial_code: '+507',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pa.png`,
    code: 'PA',
    name: 'Panama',
  },
  {
    dial_code: '+675',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pg.png`,
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    dial_code: '+595',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/py.png`,
    code: 'PY',
    name: 'Paraguay',
  },
  {
    dial_code: '+51',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pe.png`,
    code: 'PE',
    name: 'Peru',
  },
  {
    dial_code: '+63',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ph.png`,
    code: 'PH',
    name: 'Philippines',
  },
  {
    dial_code: '+64',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pn.png`,
    code: 'PN',
    name: 'Pitcairn',
  },
  {
    dial_code: '+48',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pl.png`,
    code: 'PL',
    name: 'Poland',
  },
  {
    dial_code: '+351',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pt.png`,
    code: 'PT',
    name: 'Portugal',
  },
  {
    dial_code: '+1787',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pr.png`,
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    dial_code: '+974',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/qa.png`,
    code: 'QA',
    name: 'Qatar',
  },
  {
    dial_code: '+262',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/re.png`,
    code: 'RE',
    name: 'Reunion',
  },
  {
    dial_code: '+40',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ro.png`,
    code: 'RO',
    name: 'Romania',
  },
  {
    dial_code: '+7',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ru.png`,
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    dial_code: '+250',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/rw.png`,
    code: 'RW',
    name: 'Rwanda',
  },
  {
    dial_code: '+590',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/bl.png`,
    code: 'BL',
    name: 'Saint Barthelemy',
  },
  {
    dial_code: '+290',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sh.png`,
    code: 'SH',
    name: 'Saint Helena',
  },
  {
    dial_code: '+1869',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/kn.png`,
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    dial_code: '+1758',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lc.png`,
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    dial_code: '+590',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/mf.png`,
    code: 'MF',
    name: 'Saint Martin',
  },
  {
    dial_code: '+508',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/pm.png`,
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    dial_code: '+1784',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/vc.png`,
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    dial_code: '+684',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ws.png`,
    code: 'WS',
    name: 'Samoa',
  },
  {
    dial_code: '+378',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sm.png`,
    code: 'SM',
    name: 'San Marino',
  },
  {
    dial_code: '+239',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/st.png`,
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    dial_code: '+966',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sa.png`,
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    dial_code: '+221',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sn.png`,
    code: 'SN',
    name: 'Senegal',
  },
  {
    dial_code: '+381',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/rs.png`,
    code: 'RS',
    name: 'Serbia',
  },
  {
    dial_code: '+381',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/cs.png`,
    code: 'CS',
    name: 'Serbia and Montenegro',
  },
  {
    dial_code: '+248',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sc.png`,
    code: 'SC',
    name: 'Seychelles',
  },
  {
    dial_code: '+232',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sl.png`,
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    dial_code: '+65',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sg.png`,
    code: 'SG',
    name: 'Singapore',
  },
  {
    dial_code: '+721',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sx.png`,
    code: 'SX',
    name: 'Sint Maarten',
  },
  {
    dial_code: '+421',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sk.png`,
    code: 'SK',
    name: 'Slovakia',
  },
  {
    dial_code: '+386',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/si.png`,
    code: 'SI',
    name: 'Slovenia',
  },
  {
    dial_code: '+677',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sb.png`,
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    dial_code: '+252',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/so.png`,
    code: 'SO',
    name: 'Somalia',
  },
  {
    dial_code: '+27',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/za.png`,
    code: 'ZA',
    name: 'South Africa',
  },
  {
    dial_code: '+500',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gs.png`,
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    dial_code: '+211',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ss.png`,
    code: 'SS',
    name: 'South Sudan',
  },
  {
    dial_code: '+34',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/es.png`,
    code: 'ES',
    name: 'Spain',
  },
  {
    dial_code: '+94',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/lk.png`,
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    dial_code: '+249',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sd.png`,
    code: 'SD',
    name: 'Sudan',
  },
  {
    dial_code: '+597',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sr.png`,
    code: 'SR',
    name: 'Suriname',
  },
  {
    dial_code: '+47',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sj.png`,
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    dial_code: '+268',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sz.png`,
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    dial_code: '+46',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/se.png`,
    code: 'SE',
    name: 'Sweden',
  },
  {
    dial_code: '+41',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ch.png`,
    code: 'CH',
    name: 'Switzerland',
  },
  {
    dial_code: '+963',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/sy.png`,
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    dial_code: '+886',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tw.png`,
    code: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    dial_code: '+992',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tj.png`,
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    dial_code: '+255',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tz.png`,
    code: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    dial_code: '+66',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/th.png`,
    code: 'TH',
    name: 'Thailand',
  },
  {
    dial_code: '+670',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tl.png`,
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    dial_code: '+228',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tg.png`,
    code: 'TG',
    name: 'Togo',
  },
  {
    dial_code: '+690',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tk.png`,
    code: 'TK',
    name: 'Tokelau',
  },
  {
    dial_code: '+676',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/to.png`,
    code: 'TO',
    name: 'Tonga',
  },
  {
    dial_code: '+1868',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tt.png`,
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    dial_code: '+216',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tn.png`,
    code: 'TN',
    name: 'Tunisia',
  },
  {
    dial_code: '+90',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tr.png`,
    code: 'TR',
    name: 'Turkey',
  },
  {
    dial_code: '+7370',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tm.png`,
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    dial_code: '+1649',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tc.png`,
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    dial_code: '+688',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/tv.png`,
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    dial_code: '+256',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ug.png`,
    code: 'UG',
    name: 'Uganda',
  },
  {
    dial_code: '+380',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ua.png`,
    code: 'UA',
    name: 'Ukraine',
  },
  {
    dial_code: '+971',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ae.png`,
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    dial_code: '+44',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/gb.png`,
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    dial_code: '+1',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/us.png`,
    code: 'US',
    name: 'United States',
  },
  // {
  //   dial_code: '+1',
  //   flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/um.png`,
  //   code: 'UM',
  //   name: 'United States Minor Outlying Islands',
  // },
  {
    dial_code: '+598',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/uy.png`,
    code: 'UY',
    name: 'Uruguay',
  },
  {
    dial_code: '+998',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/uz.png`,
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    dial_code: '+678',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/vu.png`,
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    dial_code: '+58',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ve.png`,
    code: 'VE',
    name: 'Venezuela',
  },
  {
    dial_code: '+84',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/vn.png`,
    code: 'VN',
    name: 'Viet Nam',
  },
  {
    dial_code: '+1284',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/vg.png`,
    code: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    dial_code: '+1340',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/vi.png`,
    code: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    dial_code: '+681',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/wf.png`,
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    dial_code: '+212',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/eh.png`,
    code: 'EH',
    name: 'Western Sahara',
  },
  {
    dial_code: '+967',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/ye.png`,
    code: 'YE',
    name: 'Yemen',
  },
  {
    dial_code: '+260',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/zm.png`,
    code: 'ZM',
    name: 'Zambia',
  },
  {
    dial_code: '+263',
    flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/flags/flags-icon/zw.png`,
    code: 'ZW',
    name: 'Zimbabwe',
  },
]

export const permissionLabels: Record<string, {label: string; color: string}> = {
  read: {label: 'Read', color: 'gray'},
  create: {label: 'Create', color: 'blue'},
  update: {label: 'Update', color: 'yellow'},
  delete: {label: 'Delete', color: 'red'},
  full: {label: 'Full Access', color: 'green'},
}

export const resourceTitles: Record<string, string> = {
  'digital-signing': 'Digital Signing',
  'board-meeting': 'Board Meeting',
  'shareholders-meeting': 'Shareholders Meeting',
  'other-meetings': 'Other Meetings',
  'data-rooms': 'Data Rooms',
  'shareholders-investors': 'Shareholders & Investors',
  'share-class': 'Share Class',
  'board-members': 'Board Members',
  'founders-promoters': 'Founders & Promoters',
  'management-team': 'Management Team',
  'legal-compliance': 'Legal & Compliance',
  'finance-accounts': 'Finance & Accounts',
  'advisors-mentors': 'Advisors & Mentors',
  'captable-management': 'captable-management',
  'shared-access-calendar': 'Calendar',
  'shared-access-inbox': 'Inbox',
  'shared-access-contacts': 'Contacts',
  'team-management': 'Team Management',
  'billing-management': 'Billing Management',
  'company-settings': 'Company Settings',
  'classification-settings': 'Classification Settings',
  'legal-hold-settings': 'Legal Hold Settings',
  'archival-settings': 'Archival Settings',
  'general-settings': 'General Settings',
  'analytics-reports': 'Analytics & Reports',
  'access-logs': 'Access Logs',
  'audit-logs': 'Audit Logs',
  'ai-chat': 'AI Chat',
}

export const moduleTitles: Record<string, string> = {
  'digital-signing': 'Digital Signing',
  'compliance-meetings': 'Compliance Meeting',
  'data-rooms': 'Data Rooms',
  'stakeholders-management': 'Stakeholders Management',
  'captable-management': 'Cap Table Management',
  'shared-access': 'Shared Access',
  'team-management': 'Team Management',
  'billing-management': 'Billing Management',
  'company-settings': 'Company Settings',
  'recordskeeper-settings': 'RecordsKeeper Settings',
}
